export default "__VITE_PUBLIC_ASSET__5d16aa3b__"